
<template>
  <div class="voice" @click.stop.prevent="playSwitch">
    <div class="background" :style="{ backgroundColor: color }"></div>
    <div v-if="control" class="control">
      <fps-icon :type="playing ? 'stop' : 'play'" :color="color" :style="{
        marginLeft: playing ? 0 : '2px'
      }" />
    </div>
    <div class="voice-wavy-line" :class="{ 'playing': loaded && playing }" :style="control ? '' : { marginLeft: 0 }">
      <span v-for="n in 9" :key="n"></span>
    </div>
    <p v-if="seconds">{{ (seconds | 0) }}"</p>
    <i v-else class="el-icon-loading" />
    <audio
      ref="audio"
      :src="dataSrc"
      preload="preload"
      @loadedmetadata="audioLoaded"
    >
    </audio>
  </div>
</template>

<script>
let playingVoice = 0

export default {
  data() {
    return {
      loaded: false,
      playing: false,
      seconds: 0,
      played: 0,
      timer: 0,
      audioDom: null,
      dataSrc: '',
    }
  },
  props: {
    src: {
      type: String,
      default: ''
    },
    // 初始長度（秒），如果傳入該參數，則不會自動預加載音頻，點擊時才會第一次加載
    initSeconds: {
      type: Number,
      default: 0
    },
    // 暂停時是否重置（归零）
    pauseReset: {
      type: Boolean,
      default: false
    },
    // 背景顏色
    color: {
      type: String,
      default: '#161F34'
    },
    // 是否顯示左側播放暫停按鈕
    control: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    styleScale() {
      return {
        transform: `scaleX(${this.seconds && this.played ? this.played / this.seconds : 0})`
      }
    },
  },
  created() {
    this.audioInit(1)
  },
  mounted() {
    this.audioInit(2)
    if (this.src) {
      this.audioDom = this.$refs['audio']
    }
  },
  watch: {
    initSeconds(val) {
      if (val) {
        this.seconds = val
        if (!this.audioDom) {
          this.audioDom = this.$refs['audio']
        }
      }
    },
    src(newVal, oldVal) {
      if (newVal && oldVal) {
        console.log(newVal, oldVal)
        this.dataSrc = ''
        this.audioInit(1)
        this.$nextTick(() => {
          this.audioInit(2)
        })
      }
    }
  },
  methods: {
    audioInit(step) {
      const isStep1 = !step || step == 1
      const isStep2 = !step || step == 2
      if (isStep1) {
        if (this.initSeconds) {
          // 不预加载，点击播放时才加载
          this.seconds = this.initSeconds
          this.loading = false
        } else if (this.src) {
          // 直接加载
          this.dataSrc = this.src
        }
      }
      if (isStep2) {
        if (this.src) {
          this.audioDom = this.$refs.audio
        }
      }
    },
    audioLoaded() {
      this.loaded = true
      if (this.audioDom) {
        this.seconds = this.audioDom.duration
        if (this.initSeconds) {
          this.playOn()
        }
      }
    },
    playSwitch() {
      if (this.playing) {
        // 暂停
        this.playOff(this.pauseReset)
      } else {
        // 播放
        this.playOn()
      }
    },
    playOff(reset) {
      if (!this.timer) return
      clearInterval(this.timer)
      this.audioDom.pause()
      if (reset) {
        this.audioDom.currentTime = 0
      }
      this.$nextTick(() => {
        this.playing = false
        if (reset) {
          this.played = 0
        }
      })
    },
    playOn() {
      if (!this.dataSrc) {
        this.loading = true
        this.dataSrc = this.src
      }
      if (!this.loaded || !this.audioDom) return
      this.audioDom.play().then(() => {
        this.playing = true
        playingVoice = this.src
        this.played++
        this.timer = setInterval(() => {
          if (playingVoice !== this.src) {
            // 同时只能播放一个音频
            this.playOff(true)
          }
          if (this.played < this.seconds) {
            // 继续播放
            this.played++
          } else {
            // 播放结束
            this.playOff(true)
          }
        }, 1000)
        this.$emit('play')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .voice {
    @include flex;
    position: relative;
    z-index: 1;
    height: 40px;
    max-height: 100%;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    .background {
      position: absolute;
      z-index: 0;
      width: 100%;
      height: 100%;
      border-radius: 40px;
    }
    .control {
      flex-shrink: 0;
      @include flex;
      position: absolute;
      z-index: 1;
      left: 12px;
      top: 50%;
      margin-top: -12px;
      width: 24px;
      height: 24px;
      border-radius: 24px;
      background-color: #fff;
    }
    .voice-wavy-line {
      position: relative;
      z-index: 1;
      height: 18px;
      margin-left: 24px;
      margin-right: 8px;
      @include voiceWavyLine;
      &.playing {
        @include voiceWavyLine('on');
      }
    }
    p {
      position: relative;
      z-index: 1;
    }
    .loading {
      width: 16px;
      height: 16px;
    }
    audio {
      position: absolute;
      z-index: 0;
      left: -1000px;
      top: -1000px;
      width: 1px;
      height: 1px;
      visibility: hidden;
      opacity: 0;
    }
    &.light {
      color: $color-gray-2;
      .background {
        background: $color-light;
        border: 1px solid $color-split;
      }
      .voice-wavy-line {
        @include voiceWavyLine('off', $color-gray-2);
      }
    }
  }
</style>
